import { z } from "zod";

export const MAX_UPLOAD_MB_DEFAULT = 500;
/** Uploads with status `needs_decision` one user may have at a time. */
export const MAX_PENDING_UPLOADS_PER_USER = 200;

export const UPLOAD_STATUSES = ["needs_decision", "completed", "discarded"] as const;
export type UploadStatus = (typeof UPLOAD_STATUSES)[number];

/** Body of `POST /api/uploads/:id/resolve`. */
export const resolveUploadSchema = z.discriminatedUnion("action", [
  z.object({ action: z.literal("attach"), bookId: z.string().min(1, "required") }),
  z.object({ action: z.literal("create") }),
  z.object({ action: z.literal("discard") }),
]);
export type ResolveUploadInput = z.infer<typeof resolveUploadSchema>;

/** Metadata extracted from a file after normalization (stored with pending uploads). */
export interface ExtractedMetadataDto {
  title: string;
  subtitle?: string;
  authors: { name: string; sortName: string }[];
  series?: { name: string; index?: number };
  language?: string;
  publisher?: string;
  publishedDate?: string;
  description?: string;
  tags: string[];
  identifiers: { type: string; value: string }[];
  hasCover: boolean;
}

export interface CandidateBookDto {
  id: string;
  title: string;
  authors: string[];
  formats: string[];
}

export interface PendingUploadDto {
  id: string;
  status: UploadStatus;
  originalFilename: string;
  format: string;
  sizeBytes: number;
  createdAt: string;
  uploader: { id: string; name: string };
  metadata: ExtractedMetadataDto;
  candidates: CandidateBookDto[];
  /** Books with the same normalized title (any author), oldest first, at most 10. */
  sameTitleBooks: CandidateBookDto[];
}
